import React, { useState, useRef, useEffect } from 'react';
import { EllipsisVerticalIcon, ChevronDownIcon } from '@heroicons/react/24/outline';

const ActionMenu = ({
    items = [],
    icon = <EllipsisVerticalIcon className="w-6 h-6" />,
    className = "",
    menuClassName = "",
    label = null
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    // Close on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    return (
        <div className={`relative ${className}`} ref={menuRef}>
            <button
                onClick={(e) => {
                    e.stopPropagation();
                    setIsOpen(!isOpen);
                }}
                className={`flex items-center justify-center transition-colors rounded-full focus:outline-none focus:ring-2 focus:ring-gold/50 ${label ? 'px-3 py-1.5 gap-2 hover:bg-black/5' : 'w-8 h-8 hover:bg-black/10 text-white hover:text-white/90'}`}
            >
                {label && <span className="text-sm font-medium">{label}</span>}
                {icon}
            </button>

            {isOpen && (
                <div
                    className={`absolute z-50 w-48 mt-2 origin-top-right bg-white border border-gold/20 rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden animate-slide-up ${menuClassName} ${window.innerWidth < 640 ? 'right-0' : 'right-0'}`}
                    style={{ minWidth: '160px' }}
                >
                    <div className="py-1">
                        {items.map((item, index) => {
                            if (item.type === 'divider') {
                                return <div key={index} className="h-px bg-gray-200 my-1" />;
                            }

                            const ItemIcon = item.icon;

                            return (
                                <button
                                    key={index}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        item.onClick();
                                        setIsOpen(false);
                                    }}
                                    className={`w-full text-left px-4 py-2.5 text-sm flex items-center gap-3 transition-colors ${item.variant === 'danger'
                                        ? 'text-red-600 hover:bg-red-50'
                                        : 'text-gray-700 hover:bg-gold/10 hover:text-gold-dark'
                                        }`}
                                >
                                    {ItemIcon && <ItemIcon className={`w-4 h-4 ${item.variant === 'danger' ? 'text-red-500' : 'text-gray-400'}`} />}
                                    {item.label}
                                </button>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ActionMenu;
